import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import settings from '../settings';
import DocumentMeta from 'react-document-meta';
import DonationsSlider from '../components/festival/donationsSlider/DonationsSlider';



class FestivalTickets extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {


    let browser = this.props.browser;

    return(
      <div>
        <div className="festivalTickets-bannerWrapper">

          <img className="desktop" src="/images/festival/home/2019/gf_banner_desktop_01.jpg" />

          <img className="mobile" src="/images/festival/home/2019/gf_banner_mobile_01.jpg" />
        </div>

        <div className="content-wrapper">
          <div className="festivalTickets-headerTagWrapper">
            <h1 className="page-heading">Welcome to the Girls' Festival ticket page!</h1>
            <p>Click on the links below to purchase tickets. And we invite you to make a donation to buy tickets for the girls in our Bay Area community who cannot afford to attend.</p>
          </div>




          <div className="festivalTicketsWrapper">

            <ul className="ticketsOList">
              <li>
                {/* BEGIN: Ticket Level Wrapper */}
                <div className="ticket-levels-wrapper">
                  <div className="ticket-icon-wrapper">
                    <img src="/images/festival/tickets/icon_checkmark_desktop.png" />
                  </div>

                  <div className="ticket-copy">
                    <div className="ticket-header">All Festival day pass</div>

                    <div className="ticket-price">
                      <p>Ages 19 and above: <span className="ticket-amount">$15</span></p>

                      <p>Ages 13 - 18: <span className="ticket-amount">$12</span></p>

                      <p>Ages 7 - 12: <span className="ticket-amount">$10</span></p>

                      <p>Kids below 7: <span className="ticket-amount">FREE</span></p>


                    </div>

                    <div className="ticket-description">
                      &nbsp;
                    </div>

                    <div className="festivalTickets-btnWrapper">
                      <a className="ticket-btn-link" href="https://www.eventbrite.com/e/worldwidewomen-4th-annual-girls-festival-tickets-59099790063" target="_blank"><div id="donate" className="donate donate-tickets-btn">
                        Buy Tickets
                      </div></a>
                    </div>

                  </div>
                </div>
                {/* END: Ticket Level Wrapper */}
              </li>


              <li>
                {/* BEGIN: Ticket Level Wrapper */}
                <div className="ticket-levels-wrapper">
                  <div className="ticket-icon-wrapper">
                    <img src="/images/festival/tickets/icon_checkmark_desktop.png" />
                  </div>

                  <div className="ticket-copy">
                    <div className="ticket-header">All day Festival pass for groups of 10 or more</div>

                    <div className="ticket-price">
                      <p>10% discount</p>
                      <p className="ticket-amount">$9</p>
                    </div>

                    <div className="ticket-description">
                      <p>We encourage you to buy blocks of tickets for your friends, teams, clubs, departments, etc.!</p>
                    </div>

                    <div className="festivalTickets-btnWrapper">
                      <a className="ticket-btn-link" href="https://www.eventbrite.com/e/worldwidewomen-4th-annual-girls-festival-tickets-59099790063" target="_blank"><div id="donate" className="donate donate-tickets-btn">
                        Buy Tickets
                      </div></a>
                    </div>

                  </div>
                </div>
                {/* END: Ticket Level Wrapper */}
              </li>

              <li>
                {/* BEGIN: Ticket Level Wrapper */}
                <div style={{'backgroundColor': '#dceffe'}} className="ticket-levels-wrapper">
                  <div className="ticket-icon-wrapper">
                    <img src="/images/festival/tickets/icon_checkmark_desktop.png" />
                  </div>

                  <div className="ticket-copy">
                    <div className="ticket-header">Donate tickets to the Festival!</div>

                    <div className="ticket-price">

                    </div>

                    <div className="ticket-description">
                      <p>With your help, we will offer free tickets to girls throughout the Bay Area who cannot afford to attend.</p>
                    </div>

                    <div className="festivalTickets-btnWrapper">
                      <a className="ticket-btn-link" href="https://www.eventbrite.com/e/worldwidewomen-4th-annual-girls-festival-tickets-59099790063" target="_blank"><div id="donate" className="donate donate-tickets-btn">
                        Donate
                      </div></a>
                    </div>

                  </div>
                </div>
                {/* END: Ticket Level Wrapper */}
              </li>
            </ul>











          </div>

          <div className="festivalTickets-donationsWrapper">
            <div className="festivalTickets-donationsCopyWrapper">
              <h3>Your donations at work</h3>
              <p>Every year, we bring girls from underserved communities throughout the San Francisco Bay Area who would otherwise not be able to attend. With help from you and our sponsors, we secure buses for the girls and their chaperones. Small snacks are provided as well.</p>
              <p>In 2016 we hosted 400 girls to our Festival at Fort Mason and in 2018 we were able to host 300 girls. Thank you for every dollar that you donated.</p>
            </div>

            <div className="festivalTickets-donationsGalleryWrapper">
              <DonationsSlider />
            </div>
          </div>
        </div>
      </div>
    )
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
  }
)(FestivalTickets);



// WEBPACK FOOTER //
// ./src/containers/FestivalTickets.jsx